import {requestTimeout, handleResponse} from '../helpers'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME
var base_uri = "transactions"

export const paymentTransactionApi = {
    _get,
    _stats,
    _export_data,
};



async function _get(offset, data, pageSize, totalRecords = 0) {
    let token = localStorage.getItem(accessToken)
    if (data) {
        data['total'] = totalRecords
    }
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime, fetch(apiUrl + base_uri + `/get/${offset}/${pageSize}`, requestOptions))
                .then(handleResponse)
                .then((response) => {
                    return response
                })
}

async function _stats(data) {
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime, fetch(apiUrl + base_uri + `/stats`, requestOptions))
                .then(handleResponse)
                .then((response) => {
                    return response
                })
    
}

async function _export_data(data) {
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri +'/export-data', requestOptions))
                .then(handleResponse)
                .then((response) => {
                    return response
                })
}
